"use client";

import { adminDeleteTags, AdminDeleteTagsData, adminGetTags } from "@/api";
import { appState } from "@/app/appState";
import { chatState } from "@/app/chatState";
import { tag_list_item } from "@/app/typing/tags";
import { usePathParam } from "@/components/path-params";
import { EntryList } from "@/components/UI/tools";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Request } from "@/components/CRUD";
import { PageBox } from "@/components/UI/page";
import { Org, User } from "@/components/UI/svgs";

const TagList = observer(() => {


    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const [id, setId] = usePathParam("tags");
    const [ids, setIds] = useState<number[]>([]);

    const [tagSearch, setTagSearch] = useState<string>("")
    const [tagPageNumber, setTagPageNumber] = useState<number>(0)

    const deleteTags = Request<AdminDeleteTagsData, any>(
        adminDeleteTags,
        () => ({
            body: {
                ids: ids!,
            },
        }),
        setDeleting,
        (data: any) => {
            appState.tags = appState.tags?.filter(x => !data.deleted_ids.includes(x.id))
            chatState.forgetDeletedObjects(data.deleted_ids.map((id: number) => ({ type: "tag", id })))
            setIds([])
        },
        (error) => {
            appState.setModal({
                title: appState.t("common.error"),
                body: appState.t("objects.errorDeleteTags"),
                comment: { name: appState.t("common.detail"), val: error.detail?.toString() ?? "" },
            })
        },
        () => ids != undefined && ids.length > 0,
    )


    useEffect(() => {
        reload();
    }, [id, tagSearch, tagPageNumber]);


    const reload = async () => {
        setLoading(true);
        await appState.getTags({ pageNumber: tagPageNumber, search: tagSearch }).finally(() => setLoading(false))
    };



    // Update form values when artifact changes

    return (
        <PageBox>


            <div className="h-full w-full ">
                <EntryList
                    name={appState.t("objects.list.tag")}
                    readonly={![4, 5, 6, 7].includes(appState.user?.active_organisation.permission_type ?? 0)}
                    search={{ get: tagSearch, set: setTagSearch }}
                    pageNumber={{ get: tagPageNumber, set: setTagPageNumber }}
                    idParams={{ singular: { get: id, set: setId }, plural: { get: ids, set: setIds } }}
                    loading={loading}
                    deleting={deleting}
                    deleteEntries={deleteTags}
                    items={appState.tags?.map((x) => {
                        return { id: x.id, lock: x.user_lock ? !(x.user_lock == appState.user?.id) : false, val: x.name + " " + x.scope, readonly: ![4, 5, 6, 7].includes(x.effective_permission_type ?? 0), showonly: ![2, 3, 4, 5, 6, 7].includes(x.effective_permission_type ?? 0) };
                    })}
                />
            </div>
        </PageBox>
    );
});

export default TagList;
